import { Tag, Tooltip } from 'antd';
import type { ColumnType, FilterValue } from 'antd/es/table/interface';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale/ru';

import {
  type IAdmissionApplicationsStats,
  EApplicationStatus,
  type IAdmissionApplication,
} from '@/api/endpoints/schools/schoolSelectionPanel';
import { DATE_FORMATTERS } from '@/shared/consts';
import { formatPhone } from '@/shared/helpers';

import { CANDIDATE_STATUS_TO_TAG_SETTINGS } from '../../consts';

import styles from './ApplicationsPage.module.scss';

export const getColumnsData = ({ filters }: { filters: Record<string, FilterValue | null> }) =>
  [
    {
      title: 'ФИО',
      dataIndex: ['user', 'full_name'],
      key: 'name',
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: ['user', 'email'],
      key: 'email',
      ellipsis: true,
    },
    {
      title: 'Телефон',
      dataIndex: ['user', 'phone'],
      key: 'phone',
      ellipsis: true,
      render: (_, { user }) => (user.phone ? formatPhone(user.phone) : '-'),
    },
    {
      title: 'Дата подачи',
      dataIndex: 'created_at',
      key: 'created_at',
      ellipsis: true,
      render: (_, { created_at: createdAt }) =>
        format(createdAt, DATE_FORMATTERS.DAY_MONTH_FULL_YEAR_SEPARATOR_HOURS_MINUTES, { locale: ru }),
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      filteredValue: filters.status || null,
      filters: [
        {
          text: CANDIDATE_STATUS_TO_TAG_SETTINGS[EApplicationStatus.Approved].text,
          value: EApplicationStatus.Approved,
        },
        {
          text: CANDIDATE_STATUS_TO_TAG_SETTINGS[EApplicationStatus.Rejected].text,
          value: EApplicationStatus.Rejected,
        },
        {
          text: CANDIDATE_STATUS_TO_TAG_SETTINGS[EApplicationStatus.OnChecking].text,
          value: EApplicationStatus.OnChecking,
        },
      ],
      render: (_, { status }) => (
        <Tag
          className={styles.tag}
          color={CANDIDATE_STATUS_TO_TAG_SETTINGS[status].color}
          icon={CANDIDATE_STATUS_TO_TAG_SETTINGS[status].icon}
        >
          {CANDIDATE_STATUS_TO_TAG_SETTINGS[status].text}
        </Tag>
      ),
    },
    {
      title: 'Причина отклонения',
      dataIndex: 'rejection_reason',
      key: 'rejection_reason',
      ellipsis: true,
      render: (_, { rejection_reason: rejectionReason }) =>
        rejectionReason ? (
          <Tooltip title={rejectionReason}>
            <p className={styles['reject-reason']}>{rejectionReason}</p>
          </Tooltip>
        ) : (
          '-'
        ),
    },
  ] as ColumnType<IAdmissionApplication>[];

export const formatApplicationsStats = (applicationsStats: IAdmissionApplicationsStats | undefined) => {
  if (!applicationsStats) {
    return;
  }

  const { total, rejected, approved, on_checking: onChecking } = applicationsStats;

  return [
    {
      id: 1,
      title: 'Всего заявок',
      value: total,
    },
    {
      id: 2,
      title: 'На проверке',
      value: onChecking,
    },
    {
      id: 3,
      title: 'Одобрено',
      value: approved,
    },
    {
      id: 4,
      title: 'Отклонено',
      value: rejected,
    },
  ];
};
